import { Close } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";

import { getSettlementTextFieldSx, SETTLEMENT_STYLES } from "../../style/styles";

export default function SettlementTextField({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  inputMode,
  startAdornment,
  isEditable = false,
  showEditIcon = false,
  showClearIcon = false,
  onEditClick,
  onClear,
  onFocus,
  onDisplayClick,
  labelAdornment,
  canEdit = true,
}) {
  const isInteractive = canEdit && !isEditable;
  const textField = (
    <TextField
      className="w-full"
      size="small"
      fullWidth
      type={type}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onClick={isInteractive ? onDisplayClick : undefined}
      placeholder={placeholder}
      inputProps={{ readOnly: !isEditable || !canEdit, inputMode }}
      sx={getSettlementTextFieldSx({ isInteractive })}
      InputProps={{
        startAdornment: startAdornment ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : null,
        endAdornment:
          showClearIcon && isEditable && value ? (
            <InputAdornment position="end" className="p-2">
              <IconButton edge="end" size="small" onClick={onClear}>
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : showEditIcon && canEdit ? (
            <InputAdornment position="end">
              <IconButton edge="end" size="small" onClick={onEditClick}>
                <EditOutlinedIcon sx={SETTLEMENT_STYLES.textFieldEditIcon} />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );

  return (
    <div className="w-full">
      <div className="mb-[6px] flex items-center gap-2">
        <Typography sx={SETTLEMENT_STYLES.fieldLabelInline}>{label}</Typography>
        {labelAdornment}
      </div>
      {!isEditable && canEdit ? (
        <Tooltip title="Click to Edit">
          <span>{textField}</span>
        </Tooltip>
      ) : (
        textField
      )}
    </div>
  );
}
